import { connect } from 'react-redux'
import RidersPane from '../../components/riders/RidersPane'
import { actionCreators } from '../../state/actions/riders'
import { IStoreState } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    currentOrgId: state.organizations.currentOrgId,
    ...ownProps
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    onCreateClear: () => {
      dispatch(actionCreators.ridersCreateClear())
    },
    onClearSearch: () => {
      dispatch(actionCreators.ridersClearSearch())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RidersPane)



// WEBPACK FOOTER //
// ./src/containers/riders/RidersPane.ts